import { ShopperBuyProductPlazalistPage } from "./../shopper-buy-product-plazalist/shopper-buy-product-plazalist";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { ShopperOverviewPlazaPage } from "./../shopper-overview-plaza/shopper-overview-plaza";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-shopping-bag",
  templateUrl: "shopper-shopping-bag.html",
})
export class ShopperShoppingBagPage {
  bags: any;
  change_plaze = 0;
  total_theme_hp = 0;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperBag;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.bags = data.items;
            this.change_plaze = data.change_plaze;
            this.total_theme_hp = data.total_theme_hp;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperBag;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.bags = data.items;
            this.change_plaze = data.change_plaze;
            this.total_theme_hp = data.total_theme_hp;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  shopping() {
    this.navCtrl.push(ShopperBuyProductPlazalistPage);
  }

  map() {
    this.navCtrl.push(ShopperOverviewPlazaPage);
  }

  backPage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-shopping-bag/shopper-shopping-bag.ts